






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Info from '@/views/AiiTasks/Info.vue'
import InfoRow from '@/views/AiiTasks/InfoRow.vue'

@Component({
	components: {
		Info,
		InfoRow,
	},
})
export default class AddTask extends Vue {
	@Prop()
	public module!: any

	@Prop()
	public order!: any
}
